import _ from 'lodash';

export function getIsRepricerFeatureEnabled(profile) {
	const enabledFlag = _.get(profile, 'repricer_enabled');
	return Boolean(enabledFlag);
}

